<div class="background-header">
  <upsc-login-header></upsc-login-header>
</div>
<div class="content">
  <div class="profile-info" *ngIf="!userCreatedSuccessfully">
    <div class="profile-header">
      {{ 'createAccount.pageTitle' | translate }}
    </div>
    <form [formGroup]="accountFormGroup">
      <div class="description">{{ 'createAccount.pageDescription' | translate }}</div>
      <div class="title mt-3" *ngIf="showMultiPolicy">Policy 1</div>
      <mat-form-field ngbTooltip="{{ 'createAccount.account.tooltip.policyTip' | translate }}" tooltipClass="ngb-tooltip-class">
        <input autocomplete="off" matInput required placeholder="{{ 'createAccount.account.form.policy' | translate }}" formControlName="policyNumberFormControl" (focusout)="formatPolicy();">
        <mat-error *ngIf="policy.errors?.required">
          <div class="error-input">
            <mat-icon>report_problem</mat-icon>
            <div class="error-text">{{ 'createAccount.account.form.policyRequired' | translate }}</div>
          </div>
        </mat-error>
        <mat-error *ngIf="policy.errors && !policy.errors?.required">
          <div class="error-input">
            <mat-icon>report_problem</mat-icon>
            <div class="error-text">{{ 'createAccount.account.form.validPolicy' | translate }}</div>
          </div>
        </mat-error>
      </mat-form-field>
      <mat-form-field *ngIf="isUsaUser || isGermanyUser || isFranceUser || isItalyUser" ngbTooltip="{{ 'createAccount.account.tooltip.zipTip' | translate }}" tooltipClass="ngb-tooltip-class">
        <input matInput required placeholder="{{ 'createAccount.account.form.zip' | translate }}" formControlName="zipFormControl" maxlength="5">
        <mat-error *ngIf="zip.errors?.required">
          <div class="error-input">
            <mat-icon>report_problem</mat-icon>
            <div class="error-text">{{ 'createAccount.account.form.zipRequired' | translate }}</div>
          </div>
        </mat-error>
        <mat-error *ngIf="zip.errors?.pattern">
          <div class="error-input">
            <mat-icon>report_problem</mat-icon>
            <div class="error-text">{{ 'common.validZip' | translate }}</div>
          </div>
        </mat-error>
      </mat-form-field>
      <mat-form-field *ngIf="isUkUser" ngbTooltip="{{ 'createAccount.account.tooltip.zipTip' | translate }}" tooltipClass="ngb-tooltip-class">
        <input matInput required placeholder="{{ 'createAccount.account.form.zip' | translate }}" formControlName="zipFormControl" maxlength="8" minlength="2">
        <mat-error *ngIf="zip.errors?.required">
          <div class="error-input">
            <mat-icon>report_problem</mat-icon>
            <div class="error-text">{{ 'createAccount.account.form.zipRequired' | translate }}</div>
          </div>
        </mat-error>
        <mat-error *ngIf="zip.errors?.pattern">
          <div class="error-input">
            <mat-icon>report_problem</mat-icon>
            <div class="error-text">{{ 'common.validZip' | translate }}</div>
          </div>
        </mat-error>
      </mat-form-field>
      <mat-form-field *ngIf="isCanadaUser" ngbTooltip="{{ 'createAccount.account.tooltip.zipTip' | translate }}" tooltipClass="ngb-tooltip-class">
        <input matInput required placeholder="{{ 'createAccount.account.form.zip' | translate }}" formControlName="zipFormControl" maxlength="7">
        <mat-error *ngIf="zip.errors?.required">
          <div class="error-input">
            <mat-icon>report_problem</mat-icon>
            <div class="error-text">{{ 'createAccount.account.form.zipRequired' | translate }}</div>
          </div>
        </mat-error>
        <mat-error *ngIf="zip.errors?.pattern">
          <div class="error-input">
            <mat-icon>report_problem</mat-icon>
            <div class="error-text">{{ 'common.validZip' | translate }}</div>
          </div>
        </mat-error>
      </mat-form-field>
      <div class="error mb-3" *ngIf="multipolicyError1">
        {{ multipolicyError1 }}
      </div>

      <div *ngIf="showMultiPolicy">
        <div class="title">Policy 2</div>
        <div class="policy-spread">
          <mat-form-field>
            <mat-label>{{ 'createAccount.account.form.policy' | translate }}</mat-label>
            <input matInput required formControlName="policy2" (focusout)="formatAdditionalPolicy('policy2');">
            <mat-error>
              <mat-icon>report_problem</mat-icon>
              <span *ngIf="policy2.errors?.required">
                {{ 'createAccount.account.form.policyRequired' | translate }}
              </span>
              <span *ngIf="!policy2.errors?.required">{{ 'createAccount.account.form.validPolicy' | translate }}</span>
            </mat-error>
          </mat-form-field>
          <mat-form-field>
            <mat-label>{{ 'createAccount.account.form.zip' | translate }}</mat-label>
            <input matInput required formControlName="zip2">
            <mat-error>
              <mat-icon>report_problem</mat-icon>
              <span *ngIf="zip2.errors?.required">{{ 'createAccount.account.form.zipRequired' | translate }}</span>
              <span *ngIf="!zip2.errors?.required">{{ 'common.validZip' | translate }}</span>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="error mb-3" *ngIf="multipolicyError2">
          {{ multipolicyError2 }}
        </div>
      </div>
      <div class="title" *ngIf="showPolicy3">Policy 3</div>
      <div class="policy-spread" *ngIf="showPolicy3">
        <mat-form-field>
          <mat-label>{{ 'createAccount.account.form.policy' | translate }}</mat-label>
          <input matInput required formControlName="policy3" (focusout)="formatAdditionalPolicy('policy3');">
          <mat-error>
            <mat-icon>report_problem</mat-icon>
            <span *ngIf="policy3.errors?.required">
              {{ 'createAccount.account.form.policyRequired' | translate }}
            </span>
            <span *ngIf="!policy3.errors?.required">{{ 'createAccount.account.form.validPolicy' | translate }}</span>
          </mat-error>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'createAccount.account.form.zip' | translate }}</mat-label>
          <input matInput required formControlName="zip3">
          <mat-error *ngIf="showPolicy3">
            <mat-icon>report_problem</mat-icon>
            <span *ngIf="zip3.errors?.required">{{ 'createAccount.account.form.zipRequired' | translate }}</span>
            <span *ngIf="!zip3.errors?.required">{{ 'common.validZip' | translate }}</span>
          </mat-error>
        </mat-form-field>
        <div class="error mb-3" *ngIf="multipolicyError3">
          {{ multipolicyError3 }}
        </div>
      </div>
      
      <div class="add" (click)="showPolicy2()" *ngIf="!isFlexAppUser && !showMultiPolicy">
        <mat-icon>add_circle</mat-icon><span>{{ 'common.addAnotherPolicy' | translate }}</span>
      </div>
      <div class="add" (click)="togglePolicy3()" *ngIf="!isFlexAppUser && showMultiPolicy && !showPolicy3">
        <mat-icon>add_circle</mat-icon><span>{{ 'common.addAnotherPolicy' | translate }}</span>
      </div>

      <mat-form-field class="mt-3">
        <input matInput required formControlName="firstName" placeholder="{{ 'createAccount.review.form.firstName' | translate }}">
        <mat-error *ngIf="fName.errors?.required">
          <div class="error-input">
            <mat-icon>report_problem</mat-icon>
            <div class="error-text">{{ 'createAccount.review.form.firstNameError' | translate }}</div>
          </div>
        </mat-error>
        <mat-error *ngIf="fName.errors && !fName.errors?.required">
          <div class="error-input">
            <mat-icon>report_problem</mat-icon>
            <div class="error-text">{{ 'createAccount.review.form.firstNamePattern' | translate }}</div>
          </div>
        </mat-error>
      </mat-form-field>
      <mat-form-field>
        <input matInput required formControlName="lastName" placeholder="{{ 'createAccount.review.form.lastName' | translate }}">
        <mat-error *ngIf="lName.errors?.required">
          <div class="error-input">
            <mat-icon>report_problem</mat-icon>
            <div class="error-text"> {{ 'createAccount.review.form.lastNameError' | translate }}</div>
          </div>
        </mat-error>
        <mat-error *ngIf="lName.errors && !lName.errors?.required">
          <div class="error-input">
            <mat-icon>report_problem</mat-icon>
            <div class="error-text"> {{ 'createAccount.review.form.lastNamePattern' | translate }}</div>
          </div>
        </mat-error>
      </mat-form-field>
      <!-- <div *ngIf="showAdminToggle" class="admin-toggle">
        {{ 'createAccount.review.admin' | translate }}
        <span class="ml-2">
          <mat-slide-toggle formControlName="adminControl" color="primary"></mat-slide-toggle>
        </span>
      </div> -->
      <div class="checkbox-wrapper">
        <mat-checkbox class="green-background-checkbox create-account-layout" formControlName="checkBoxFormControl"></mat-checkbox>
        {{ 'createAccount.review.form.checkbox' | translate }}
        <a href="{{ privacyLink }}" *ngIf="isUsaUser" target="_blank" rel="noopener noreferrer">
          {{ 'createAccount.review.form.checkboxLink' | translate }}
        </a>
        <a href="{{ ukprivacyNotice }}" *ngIf="isUkUser" target="_blank" rel="noopener noreferrer">
          {{ 'createAccount.review.form.checkboxLink' | translate }}
        </a>
        <a href="{{ deprivacyNotice }}" *ngIf="isGermanyUser" target="_blank" rel="noopener noreferrer">
          {{ 'createAccount.review.form.checkboxLink' | translate }}
        </a>
        <a href="{{ frprivacyNotice }}" *ngIf="isFranceUser" target="_blank" rel="noopener noreferrer">
          {{ 'createAccount.review.form.checkboxLink' | translate }}
        </a>
        <a href="{{ itprivacyNotice }}" *ngIf="isItalyUser" target="_blank" rel="noopener noreferrer">
          {{ 'createAccount.review.form.checkboxLink' | translate }}
        </a>
        <a href="{{ canadaprivacyLink }}" *ngIf="isCanadaUser" target="_blank" rel="noopener noreferrer">
          {{ 'createAccount.review.form.checkboxLink' | translate }}
        </a>
        {{ 'createAccount.review.form.checkbox1.5' | translate }}
        <a href="{{ deTechAgreementLink }}" target="_blank" *ngIf="isGermanyUser">
          {{ 'createAccount.review.form.checkboxLink2' | translate }}
        </a>
        <a href="{{ frTechAgreementLink }}" target="_blank" *ngIf="isFranceUser">
          {{ 'createAccount.review.form.checkboxLink2' | translate }}
        </a>
        <a href="{{ itTechAgreementLink }}" target="_blank" *ngIf="isItalyUser">
          {{ 'createAccount.review.form.checkboxLink2' | translate }}
        </a>
        <a href="{{ techAgreementLink }}" target="_blank" *ngIf="isUsaUser || isCanadaUser || isUkUser">
          {{ 'createAccount.review.form.checkboxLink2' | translate }}
        </a>
        {{ 'createAccount.review.form.checkbox2' | translate }}
      </div>

      <div class="step-controls">
        <button *ngIf="!apiInProgress" class="upsc-primary-button icon-right" role="button" type="button" (click)="submit()">
          {{ 'createAccount.account.form.createAccount' | translate }}<mat-icon>chevron_right</mat-icon>
        </button>
        <button *ngIf="apiInProgress" class="upsc-primary-button icon-right" role="button" type="button" disabled>
          {{ 'createAccount.account.form.createAccount' | translate }}<span class="spinner-border"></span>
        </button>
        <a class="cancel" (click)="cancel()">
          {{ 'createAccount.account.form.cancel' | translate }}
        </a>
      </div>

      <div class="error" *ngIf="errorReturned">
        {{ 'createAccount.account.form.errorReturned' | translate}}
      </div>
      <div class="error" *ngIf="isInvalidData">
        {{ 'createAccount.account.form.isInvalidData' | translate}}
      </div>
      <div class="error" *ngIf="isNullData">
        {{ 'createAccount.account.form.isNullData' | translate}}
      </div>
      <div class="error" *ngIf="systemError">
        {{ 'createAccount.account.form.systemError' | translate}}
      </div>
      <div class="error" *ngIf="scriptError">
        Invalid Input
      </div>
    </form>
  </div>
  <div class="success" *ngIf="userCreatedSuccessfully">
    <img class="check-circle" src="../../../assets/images/check_circle.png">
    <div class="success-title" *ngIf="user.approved">{{'createAccount.success.title' | translate}} </div>
    <div class="success-subtext bold" *ngIf="user.approved">{{'createAccount.success.title2' | translate}} </div>
    <div class="success-title" *ngIf="!user.approved"> {{'createAccount.success.non_Admin_title' | translate}}</div>
    <div class="success-subtext bold" *ngIf="!user.approved"> {{'createAccount.success.non_Admin_title2' | translate}}
    </div>
    <!-- <div class="success-subtext" *ngIf="allowedToEarnDWPoints">
      {{'createAccount.success.DWEarnedPoints1' | translate}}
      <span class="green">{{'createAccount.success.DWEarnedPoints2' | translate }}</span>{{'createAccount.success.DWEarnedPoints3' | translate }}<sup>®</sup>
      {{'createAccount.success.DWEarnedPoints4' | translate }}<sup>®</sup>{{'createAccount.success.DWEarnedPoints5' | translate }}
    </div> -->
    <button class="upsc-primary-button" (click)="tagging(); goToLoginPage()">
      {{'createAccount.success.button' | translate}}<mat-icon>keyboard_arrow_right</mat-icon>
    </button>
    <div class="error mt-3" *ngIf="multiPolicySaveHadAnError">
      The system encountered an issue while trying to add additional policies to your account. Please login and try
      again from the dashboard.
    </div>
    <div class="error mt-3" *ngIf="multiPolicySaveApprovalError">
      One or more additional policies to your account is pending administrator approval.
    </div>
  </div>
</div>

<div class="footer">
  <upsc-footer></upsc-footer>
</div>